import axios from "axios";
import config from "@/config/constants";
import store from "./src/store";

export const fetchServices = async () => {
  // uncomment for development only
  // const response = await axios.get('/my_health.json');
  // return response

  const payload = {
    user_id: store.getters.user_id
  };
  return await axios.post(
    config.api_env + "/application/api/u/dmh/get-services",
    payload,
    config.options
  );
};

export const getServices = async () => {
  try {
    const res = await fetchServices();

    if (res.status === 200 && res.data.success) {
      const services = res.data.my_health;
      await store.dispatch("updateServices", services);
    } else if (res.data.err && res.data.err.includes("3994")) {
      await store.dispatch("logout");
      await this.$router.push("/login");
    } else {
      await store.dispatch("updateServices", []);
    }
  } catch (err) {
    // console.error(err)
  }
};

export const getNavigationTags = async () => {
  // uncomment for development only
  // const response = await axios.get('/navigation_tags.json');
  // return response

  const payload = {
    user_id: store.getters.user_id
  };
  const res = await axios.post(
    config.api_env + "/application/api/u/dmh/get-navigation-tags",
    payload,
    config.options
  );
  return res;
};
